import { NgModule } from '@angular/core';
import { ShareModule } from './share/share.module';
import { ProfileModule } from './profile/profile.module';
import { HeaderModule } from './header';
import { CommonModule as CommonNimbusModule } from './common/common.module';
import { LoginModule } from './login';
import { EmbedModule } from './embed';
import { ErrorsModule } from './errors';
import { WorkspacesModule } from './workspaces';
import { ShareCopyService } from './share';
import { ProfileService } from './profile/profile.service';
import { GoogleAnalyticsComponent } from './analytics/google-analytics.component';
import { OrganizationsModule } from './organizations';
import { APP_BASE_HREF } from '@angular/common';
import { ShareErrorsService } from './share/share-errors.service';
import { BrandingModule } from './branding';
import { NoteImageViewerComponent } from './share/note/noteImageViewer/NoteImageViewer.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MetricsService } from './metrics.service';
import { QueryService } from '../query.service';

@NgModule({
  imports: [
    CommonNimbusModule,
    HeaderModule,
    LoginModule,
    ShareModule,
    ProfileModule,
    ErrorsModule,
    OrganizationsModule,
    WorkspacesModule,
    EmbedModule,
    BrandingModule,
    NoopAnimationsModule,
  ],
  providers: [
    ProfileService,
    ShareCopyService,
    ShareErrorsService,
    MetricsService,
    QueryService,
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  declarations: [
    GoogleAnalyticsComponent,
    NoteImageViewerComponent,
  ],
  exports: [
    CommonNimbusModule,
    HeaderModule,
    LoginModule,
    ShareModule,
    ProfileModule,
    ErrorsModule,
    OrganizationsModule,
    WorkspacesModule,
    EmbedModule,
    GoogleAnalyticsComponent,
    NoteImageViewerComponent
  ]
})
export class AppModule { }
